import { render, staticRenderFns } from "./SiloBlockPage.vue?vue&type=template&id=97157b24&scoped=true&"
import script from "./SiloBlockPage.vue?vue&type=script&lang=js&"
export * from "./SiloBlockPage.vue?vue&type=script&lang=js&"
import style0 from "./SiloBlockPage.vue?vue&type=style&index=0&id=97157b24&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97157b24",
  null
  
)

export default component.exports